<h2>{{ 'CLIENT.VEHICLES.DOCUMENTS.DOCUMENT_RECORDS' | translate }}</h2>

<lin-table [dataSource]="dataSource" matSort matSortDisabled>
  <!--Issue date -->
  <lin-table-column name="issueDate" [label]="'FIELDS.issueDate' | translate">
    <lin-cell-text *ng="let record">{{ record.issueDate | dayjsDate }}</lin-cell-text>
  </lin-table-column>

  <!--Expiration date -->
  <lin-table-column name="expDate" [label]="'FIELDS.expirationDate' | translate">
    <lin-cell-text *ng="let record">{{ record.expDate | dayjsDate }}</lin-cell-text>
  </lin-table-column>

  <!--User -->
  <lin-table-column name="user" [label]="'FIELDS.user' | translate">
    <lin-cell-text *ng="let record">{{ record.createdBy.fullName }}</lin-cell-text>
  </lin-table-column>

  <!--Cost -->
  <lin-table-column name="cost" [currencyColumn]="true">
    <lin-cell-text *ng="let record">{{ record.cost | platformCurrency }}</lin-cell-text>
  </lin-table-column>

  <!--Files -->
  <lin-table-column name="filesAttached" [label]="'FIELDS.filesAttached' | translate" nonSortable>
    <lin-cell-multiline-text *ng="let record">
      @for (file of record.files; track file.id) {
      <div>
        <a [href]="file.path + file.name" target="_blank">{{ file.displayName }}</a>
      </div>
      }
    </lin-cell-multiline-text>
  </lin-table-column>

  <!--Notes -->
  <lin-table-column name="notes" [label]="'FIELDS.notes' | translate" nonSortable>
    <lin-cell-text *ng="let record">
      @if (record.note) {
      <lin-tooltip label="{{ record.note }}">
        <mat-icon svgIcon="list_alt"></mat-icon>
      </lin-tooltip>
      }
    </lin-cell-text>
  </lin-table-column>

  <!-- Edit Column -->
  <ng-container matColumnDef="edit">
    <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'ADMIN.ADMIN_TEAM.EDIT' | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let record; let i = index" class="g-table-column-icon">
      <button mat-icon-button [matTooltip]="'ADMIN.ADMIN_TEAM.EDIT' | translate" (click)="handleEditRecord(record, i)">
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="settings.columnsDisplayed; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: settings.columnsDisplayed"></mat-row>
</lin-table>

<lin-table-toolbar>
  <div></div>
  <mat-paginator linPaginatorDefault></mat-paginator>
</lin-table-toolbar>

<lin-table-settings #settings [columns]="columns" [columnsMandatory]="columnsMandatory" [disableExportPDF]="true"></lin-table-settings>
